import React from "react";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "components/ui/dialog";

/**
 * Shared "Create webhook" modal used by both the Settings → Webhooks page and
 * the Tasks (new/edit) form, so the create UI stays identical everywhere.
 */
function CreateWebhookModal({
  open,
  name,
  onNameChange,
  creating = false,
  error = "",
  onCreate,
  onClose,
}) {
  const handleOpenChange = (next) => {
    if (!next && !creating) onClose?.();
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[440px]">
        <DialogHeader>
          <DialogTitle>Create webhook</DialogTitle>
          <DialogDescription>
            Create a new webhook endpoint to receive events from external services.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2">
          <label className="block text-[13px] font-medium text-muted-foreground">
            Webhook name
          </label>
          <Input
            autoFocus
            type="text"
            value={name}
            disabled={creating}
            onChange={(event) => onNameChange?.(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                onCreate?.();
              }
            }}
            placeholder="e.g. Fireflies integration"
          />
          <p className="text-[12px] text-muted-foreground">
            Give your webhook a descriptive name to identify it later.
          </p>
          {error && <p className="mt-1 text-sm text-destructive">{error}</p>}
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="ghost"
            onClick={() => handleOpenChange(false)}
            disabled={creating}
          >
            Cancel
          </Button>
          <Button
            type="button"
            disabled={!name?.trim() || creating}
            onClick={onCreate}
          >
            {creating ? "Creating…" : "Create"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default CreateWebhookModal;
